import { render, staticRenderFns } from "./builtin.vue?vue&type=template&id=6fdeacca&scoped=true&lang=pug"
import script from "./builtin.vue?vue&type=script&lang=js"
export * from "./builtin.vue?vue&type=script&lang=js"
import style0 from "./builtin.vue?vue&type=style&index=0&id=6fdeacca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdeacca",
  null
  
)

export default component.exports